import React, { useState } from "react";
import { Link } from "react-router-dom";
import Star from "./Star";
import axiosInstance from "../../../axios";
const { REACT_APP_LOGIN_API_BASEURL } = process.env;
const RateCourse = ({
  onClose,
  rating,
  setRating,
  handleRateCourse,
  course,
}) => {
  const [hovered, setHovered] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSelection = (index, isHovered = false) => {
    return isHovered ? setHovered(index) : setRating(index);
  };

  const getStyleName = (index, selection) => {
    return index <= selection ? "hover-star" : "normal-star";
  };

  const submitRating = async () => {
    if (rating === 0) {
      alert("Please select a rating.");
      return;
    }

    setIsSubmitting(true);
    try {
      const res = await axiosInstance.post(
        `${REACT_APP_LOGIN_API_BASEURL}/course/rate`,
        {
          courseId: course.ID, // Assuming `course.ID` is the correct identifier
          rating: rating,
        }
      );
      if (res.data.error) {
        alert("Error: " + res.data.message);
      } else {
        alert("Your rating has been submitted!");
        onClose(); // Close the modal after successful submission
      }
    } catch (error) {
      console.error("Error submitting rating:", error);
      alert("There was an error submitting your rating. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <div className="rate-course">
      <div className="arrow-up"></div>
      <div className="close-button" onClick={() => onClose()}>
        <i className="icon check"></i>
      </div>
      <div className="star-text">How would you rate this course?</div>
      <div className="star-rating star-div">
        {[...Array(5)].map((_, index) => {
          index = index + 1;
          return (
            <button
              key={index}
              onMouseOver={() => handleSelection(index, true)}
              onMouseOut={() => setHovered(0)}
              onClick={() => handleSelection(index)}
            >
              <Star
                style={
                  rating && index <= rating
                    ? "full-star"
                    : getStyleName(index, hovered)
                }
              />
            </button>
          );
        })}
      </div>
      <div className="button-wrapper">
        <div className="btn btn-back">
          <a onClick={() => onClose()}>Later</a>
        </div>
        <div
          className="btn rate"
          onClick={submitRating}
          disabled={isSubmitting} // Disable the button while submitting
        >
          <Link>Rate</Link>
        </div>
      </div>
    </div>
  );
};

export default RateCourse;

